import type { Stripe } from '@stripe/stripe-js';

export async function confirmStripePayment(
  stripe: Stripe,
  clientSecret: string,
) {
  const { error, paymentIntent } =
    await stripe.confirmCardPayment(clientSecret);
  if (error) {
    throw error;
  }
  return paymentIntent;
}
